(() => {
  const root = document.querySelector('[data-premium-product]');
  if (!root) return;

  const form = root.querySelector('[data-premium-product-form]');
  const variantInput = root.querySelector('[data-variant-id]');
  const variantsScript = root.querySelector('[data-product-variants]');
  const priceNode = root.querySelector('[data-product-price]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const addLabel = root.querySelector('[data-add-label]');
  const cartError = root.querySelector('[data-product-cart-error]');
  let adding = false;
  let addedSelection = null;
  const selectionKey = () => JSON.stringify(Array.from(new FormData(form).entries()));
  const fitSelector = root.querySelector('[data-fit-selector]');
  const fitProperty = root.querySelector('[data-fit-property]');
  const customPanel = root.querySelector('[data-custom-measurements]');
  const unstitchedPanel = root.querySelector('[data-unstitched-panel]');
  const measurementStatus = root.querySelector('[data-measurement-status]');
  const laterToggle = root.querySelector('[data-submit-measurements-later]');
  const manualSizePanel = root.querySelector('[data-manual-standard-size]');
  const manualSizeProperty = root.querySelector('[data-manual-size-property]');
  const saveMeasurementsButton = root.querySelector('[data-save-measurements]');
  const saveMeasurementsStatus = root.querySelector('[data-measure-save-status]');
  const savedMeasurementsSelect = root.querySelector('[data-saved-measurements]');
  const measurementName = root.querySelector('[data-measurement-name]');
  const currency = window.Shopify?.currency?.active || root.dataset.currency || 'USD';
  const locale = document.documentElement.lang || 'en';
  const measurementStorageKey = 'ethnicwish_measurement_profiles_v1';

  let variants = [];
  try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch (_) {}

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    } catch (_) {
      return (Number(cents || 0) / 100).toFixed(2);
    }
  };

  root.querySelectorAll('[data-media-target]').forEach((button) => {
    button.addEventListener('click', () => {
      const id = button.dataset.mediaTarget;
      root.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      root.querySelectorAll('[data-media-id]').forEach((media) => {
        const active = media.dataset.mediaId === id;
        media.hidden = !active;
        media.classList.toggle('is-active', active);
        const video = media.querySelector('video');
        if (video && !active) video.pause();
      });
    });
  });

  const optionGroups = Array.from(root.querySelectorAll('[data-option-position]'));
  const activeServices = () => [
    root.querySelector(`[data-fit-choice="${fitMode}"][data-paid-tailoring]`),
    root.querySelector('[data-petticoat-service]:checked')
  ].filter(Boolean);
  const selectedValues = () => optionGroups.map((group) => group.querySelector('[data-option-value].is-active')?.dataset.optionValue || '');
  const resolveVariant = () => {
    if (!variants.length) return null;
    const chosen = selectedValues();
    if (!chosen.some(Boolean)) return variants.find((variant) => String(variant.id) === variantInput?.value) || variants.find((variant) => variant.available) || variants[0];
    return variants.find((variant) => chosen.every((value, index) => !value || variant.options?.[index] === value)) || null;
  };

  const syncVariant = () => {
    const variant = resolveVariant();
    const discountBadge = root.querySelector('[data-product-discount]');
    if (!variant) {
      if (discountBadge) discountBadge.hidden = true;
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = addButton.dataset.labelUnavailable || 'Unavailable';
      return;
    }
    if (discountBadge) {
      const percent = variant.compare_at_price > variant.price
        ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      discountBadge.hidden = percent < 1;
      discountBadge.querySelector('[data-discount-percent]').textContent = `${percent}%`;
    }
    if (variantInput) variantInput.value = variant.id;
    const fee = activeServices().reduce((total, service) => total + Number(service.dataset.tailoringPrice || 0), 0);
    if (priceNode) {
      priceNode.dataset.ewMoney = variant.price + fee;
      priceNode.textContent = money(variant.price + fee);
      window.EthnicWishCurrency?.refresh(priceNode);
    }
    const compare = root.querySelector('[data-product-compare]');
    if (compare) {
      compare.hidden = !(variant.compare_at_price > variant.price);
      const amount = compare.querySelector('[data-ew-money]');
      amount.dataset.ewMoney = variant.compare_at_price ? variant.compare_at_price + fee : 0;
      amount.textContent = money(variant.compare_at_price ? variant.compare_at_price + fee : 0);
      window.EthnicWishCurrency?.refresh(amount);
    }
    if (addButton) addButton.disabled = adding || !variant.available;
    if (addLabel) addLabel.textContent = adding ? addButton.dataset.labelAdding : (variant.available ? (addedSelection === selectionKey() ? addButton.dataset.labelViewCart : addButton.dataset.labelAdd) : addButton.dataset.labelSoldOut);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  root.querySelectorAll('[data-option-value]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-option-position]');
      group?.querySelectorAll('[data-option-value]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      syncVariant();
    });
  });

  root.querySelectorAll('[data-manual-size-value]').forEach((button) => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-manual-size-value]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (manualSizeProperty) manualSizeProperty.value = button.dataset.manualSizeValue || '';
    });
  });

  let fitMode = fitSelector?.dataset.initialFit || root.querySelector('[data-fit-choice].is-active')?.dataset.fitChoice || 'standard';

  const measurementInputs = () => Array.from(root.querySelectorAll('[data-measurement-field], [data-measurement-unit]'));
  const requiredMeasurementInputs = () => Array.from(root.querySelectorAll('[data-measurement-name], input[data-measure-key]'));

  const syncMeasurementAvailability = () => {
    const isCustom = fitMode === 'custom';
    const submitLater = Boolean(isCustom && laterToggle?.checked);
    if (measurementStatus) measurementStatus.value = isCustom ? (submitLater ? 'Submit later' : 'Provided now') : '';
    requiredMeasurementInputs().forEach((input) => {
      if (!isCustom || submitLater || input.value.trim()) input.setCustomValidity('');
    });
    if (laterToggle) laterToggle.disabled = !isCustom;

    measurementInputs().forEach((input) => {
      input.disabled = !isCustom || submitLater;
    });
    if (saveMeasurementsButton) saveMeasurementsButton.disabled = !isCustom || submitLater;
    if (savedMeasurementsSelect) savedMeasurementsSelect.disabled = !isCustom || submitLater;

    root.querySelector('[data-measurement-fields]')?.classList.toggle('is-disabled', submitLater);
    root.querySelector('.ew-measure-profile-row')?.classList.toggle('is-disabled', submitLater);
  };

  const fitLabel = (mode) => {
    const label = root.querySelector(`[data-fit-choice="${mode}"]`)?.dataset.fitLabel;
    if (label) return label;
    if (mode === 'custom') return 'Made to Measure';
    if (mode === 'unstitched') return 'Unstitched';
    return 'Standard Size';
  };

  const syncExtraMeasurements = () => {
    [[root.querySelector('[data-standard-blouse]'), fitMode === 'standard'],
     [root.querySelector('[data-petticoat-measurements]'), Boolean(root.querySelector('[data-petticoat-service]:checked'))]
    ].forEach(([panel, enabled]) => {
      if (!panel) return;
      panel.hidden = !enabled;
      panel.querySelectorAll('input, select').forEach((input) => {
        input.disabled = !enabled;
        input.required = enabled && input.hasAttribute('data-tailoring-required');
        if (!enabled) input.setCustomValidity('');
      });
    });
  };
  root.querySelectorAll('[data-petticoat-choice]').forEach((input) => input.addEventListener('change', () => {
    syncExtraMeasurements();
    syncVariant();
  }));

  const mtmDialog = root.querySelector('[data-mtm-dialog]');
  let mtmReturnFocus;
  let mtmPreviousOverflow = '';
  const mtmTabs = Array.from(root.querySelectorAll('[data-mtm-tab]'));
  const selectMtmTab = (name) => {
    mtmTabs.forEach((tab) => {
      const active = tab.dataset.mtmTab === name;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-mtm-panel]').forEach(panel => { panel.hidden = panel.dataset.mtmPanel !== name; });
    mtmDialog?.querySelectorAll('video').forEach(video => {
      if (name === 'video') video.play().catch(() => {});
      else video.pause();
    });
  };
  const openMtm = () => {
    if (!mtmDialog || mtmDialog.open) return;
    mtmReturnFocus = document.activeElement;
    mtmPreviousOverflow = document.body.style.overflow;
    selectMtmTab('measure');
    mtmDialog.showModal();
    document.body.style.overflow = 'hidden';
    mtmDialog.querySelector('[data-mtm-close]').focus();
  };
  const closeMtm = () => mtmDialog?.close();
  mtmDialog?.addEventListener('close', () => {
    document.body.style.overflow = mtmPreviousOverflow;
    mtmDialog.querySelectorAll('video').forEach(video => { video.pause(); video.currentTime = 0; });
    mtmReturnFocus?.focus();
  });
  root.querySelector('[data-mtm-open]')?.addEventListener('click', openMtm);
  root.querySelector('[data-mtm-close]')?.addEventListener('click', closeMtm);
  mtmTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectMtmTab(tab.dataset.mtmTab));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? mtmTabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + mtmTabs.length) % mtmTabs.length;
      selectMtmTab(mtmTabs[next].dataset.mtmTab);
      mtmTabs[next].focus();
    });
  });
  root.querySelectorAll('[data-mtm-field-help]').forEach(button => button.addEventListener('click', () => selectMtmTab('video')));
  const validateMtm = () => {
    if (laterToggle?.checked) return true;
    const invalid = requiredMeasurementInputs().find(input => !input.value.trim() || !input.checkValidity());
    if (!invalid) return true;
    selectMtmTab('measure');
    invalid.setCustomValidity(addButton.dataset.measurementMessage || 'Please enter a valid measurement.');
    invalid.focus();
    invalid.reportValidity();
    invalid.addEventListener('input', () => invalid.setCustomValidity(''), { once: true });
    return false;
  };
  root.querySelector('[data-mtm-done]')?.addEventListener('click', () => {
    if (!validateMtm()) return;
    if (!laterToggle?.checked) saveMeasurementsButton?.click();
    root.querySelector('[data-mtm-summary]').textContent = laterToggle?.checked ? mtmDialog.dataset.pendingLabel : mtmDialog.dataset.savedLabel;
    root.querySelector('[data-mtm-open]').textContent = mtmDialog.dataset.editLabel;
    closeMtm();
  });
  root.querySelector('[data-mtm-later]')?.addEventListener('click', () => {
    if (laterToggle) { laterToggle.checked = true; syncMeasurementAvailability(); }
    root.querySelector('[data-mtm-done]')?.click();
  });
  if (window.matchMedia?.('(max-width: 749px)').matches) {
    const diagram = root.querySelector('.ew-mtm-diagram');
    if (diagram) diagram.open = false;
  }

  const syncFitMode = () => {
    if (fitProperty) fitProperty.value = fitLabel(fitMode);
    root.querySelectorAll('[data-fit-choice]').forEach((item) => {
      const active = item.dataset.fitChoice === fitMode;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (customPanel) customPanel.hidden = fitMode !== 'custom';
    if (unstitchedPanel) unstitchedPanel.hidden = fitMode !== 'unstitched';
    root.querySelectorAll('[data-size-option]').forEach((group) => { group.hidden = fitMode !== 'standard' || fitSelector?.dataset.tailoringKind === 'saree'; });
    if (manualSizePanel) manualSizePanel.hidden = fitMode !== 'standard';
    if (manualSizeProperty) manualSizeProperty.disabled = fitMode !== 'standard';

    syncMeasurementAvailability();
    syncExtraMeasurements();
    syncVariant();
  };

  root.querySelectorAll('[data-fit-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      fitMode = button.dataset.fitChoice || 'standard';
      syncFitMode();
    });
  });

  laterToggle?.addEventListener('change', syncMeasurementAvailability);

  const getProfiles = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(measurementStorageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  };

  const setProfiles = (profiles) => {
    try { localStorage.setItem(measurementStorageKey, JSON.stringify(profiles.slice(0, 12))); } catch (_) {}
  };

  const refreshProfileOptions = (selectedName = '') => {
    if (!savedMeasurementsSelect) return;
    const profiles = getProfiles();
    savedMeasurementsSelect.innerHTML = '<option value="">Choose saved profile</option>';
    profiles.forEach((profile) => {
      const option = document.createElement('option');
      option.value = profile.name;
      option.textContent = profile.name;
      option.selected = profile.name === selectedName;
      savedMeasurementsSelect.appendChild(option);
    });
  };

  const currentMeasurementProfile = () => {
    const name = measurementName?.value.trim() || '';
    const unit = root.querySelector('[data-measurement-unit]:checked')?.value || 'Inches';
    const fields = {};
    root.querySelectorAll('input[data-measure-key]').forEach((input) => { fields[input.dataset.measureKey] = input.value; });
    const notes = root.querySelector('[name="properties[Tailoring notes]"]')?.value || '';
    return { name, unit, fields, notes, updatedAt: Date.now() };
  };

  saveMeasurementsButton?.addEventListener('click', () => {
    const profile = currentMeasurementProfile();
    if (!profile.name) {
      measurementName?.focus();
      if (saveMeasurementsStatus) saveMeasurementsStatus.textContent = 'Add a measurement name first.';
      return;
    }
    const profiles = getProfiles().filter((item) => item.name.toLowerCase() !== profile.name.toLowerCase());
    profiles.unshift(profile);
    setProfiles(profiles);
    refreshProfileOptions(profile.name);
    if (saveMeasurementsStatus) saveMeasurementsStatus.textContent = 'Saved on this device.';
  });

  savedMeasurementsSelect?.addEventListener('change', () => {
    const profile = getProfiles().find((item) => item.name === savedMeasurementsSelect.value);
    if (!profile) return;
    if (measurementName) measurementName.value = profile.name || '';
    root.querySelectorAll('input[data-measure-key]').forEach((input) => { input.value = profile.fields?.[input.dataset.measureKey] || ''; });
    const unitInput = Array.from(root.querySelectorAll('[data-measurement-unit]')).find((input) => input.value === profile.unit);
    if (unitInput) unitInput.checked = true;
    const notes = root.querySelector('[name="properties[Tailoring notes]"]');
    if (notes) notes.value = profile.notes || '';
    if (laterToggle) laterToggle.checked = false;
    syncMeasurementAvailability();
    if (saveMeasurementsStatus) saveMeasurementsStatus.textContent = `Loaded ${profile.name}.`;
  });

  refreshProfileOptions();

  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('.ew-pdp-drawer__close')?.focus();
  };
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  root.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => openDrawer(root.querySelector('[data-size-guide]'))));
  root.querySelectorAll('[data-measure-guide-open]').forEach((button) => button.addEventListener('click', () => openDrawer(root.querySelector('[data-measure-guide]'))));
  root.querySelectorAll('[data-guide-close]').forEach((button) => button.addEventListener('click', () => closeDrawer(button.closest('.ew-pdp-drawer'))));

  const doDontModal = root.querySelector('[data-measure-dodont]');
  const doDontTitle = root.querySelector('[data-measure-dodont-title]');
  const doDontContent = root.querySelector('[data-measure-dodont-content]');
  const measurementTitles = {
    height: 'Body Height', bust: 'Bust', waist: 'Natural Waist', shoulder: 'Shoulder', armhole: 'Arm Hole', hip: 'Full Hip', waist_to_floor: 'Waist to Floor', bottom_waist: 'Bottom Waist Circumference'
  };

  const openDoDont = (key) => {
    if (!doDontModal || !doDontContent) return;
    const template = Array.from(root.querySelectorAll('[data-measure-guide-template]')).find((item) => item.dataset.measureGuideTemplate === key);
    if (doDontTitle) doDontTitle.textContent = `${measurementTitles[key] || 'Measurement'} — DO / DON'T`;
    doDontContent.innerHTML = template?.innerHTML || `
      <div class="ew-measure-dodont__grid">
        <section class="ew-measure-dodont__card ew-measure-dodont__card--do"><div class="ew-measure-dodont__badge"><span>✓</span> DO</div><div class="ew-measure-dodont__copy"><p>Keep the tape level, flat and comfortably snug against the body.</p></div></section>
        <section class="ew-measure-dodont__card ew-measure-dodont__card--dont"><div class="ew-measure-dodont__badge"><span>×</span> DON'T</div><div class="ew-measure-dodont__copy"><p>Do not pull the tape tight, leave excess slack, or hold it diagonally.</p></div></section>
      </div>`;
    doDontModal.hidden = false;
    doDontModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    doDontModal.querySelector('.ew-measure-dodont__close')?.focus();
  };

  const closeDoDont = () => {
    if (!doDontModal) return;
    doDontModal.hidden = true;
    doDontModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  root.querySelectorAll('[data-measure-dodont-open]').forEach((button) => button.addEventListener('click', () => openDoDont(button.dataset.measureDodontOpen)));
  root.querySelectorAll('[data-measure-dodont-close]').forEach((button) => button.addEventListener('click', closeDoDont));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    root.querySelectorAll('.ew-pdp-drawer:not([hidden])').forEach(closeDrawer);
    if (doDontModal && !doDontModal.hidden) closeDoDont();
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (adding || !variantInput?.value || addButton?.disabled) return;
    if (addedSelection === selectionKey()) {
      window.location.assign(form.dataset.cartUrl || '/cart');
      return;
    }
    if (cartError) { cartError.hidden = true; cartError.textContent = ''; }

    const submitLater = Boolean(fitMode === 'custom' && laterToggle?.checked);
    if (fitMode === 'custom' && !submitLater) {
      const missing = requiredMeasurementInputs().find((input) => !input?.value.trim());
      if (missing) {
        openMtm();
        missing.focus();
        missing.setCustomValidity(addButton.dataset.measurementMessage);
        missing.reportValidity();
        missing.addEventListener('input', () => missing.setCustomValidity(''), { once: true });
        return;
      }
    }

    if (fitMode === 'custom' && !submitLater && requiredMeasurementInputs().some(input => !input.checkValidity())) { openMtm(); validateMtm(); return; }
    if (!form.reportValidity()) return;

    const formData = new FormData(form);
    const properties = {};
    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim()) properties[match[1]] = value;
    });

    const items = [{ id: Number(variantInput.value), quantity: 1, properties }];

    const services = activeServices();
    if (services.some((service) => !Number(service.dataset.tailoringVariant))) {
      if (cartError) {
        cartError.textContent = root.dataset.tailoringUnavailable || 'This tailoring service is currently unavailable.';
        cartError.hidden = false;
        cartError.focus();
      }
      return;
    }
    if (services.length) {
      const group = crypto.randomUUID();
      properties._ew_tailoring_group = group;
      services.forEach((service) => items.push({
        id: Number(service.dataset.tailoringVariant), quantity: 1,
        properties: { _ew_tailoring_group: group, _ew_tailoring_service: 'true', _attached_to: String(variantInput.value), Service: service.dataset.fitLabel || fitLabel(fitMode) }
      }));
    }

    root.querySelectorAll('[data-addon-variant]:checked').forEach((checkbox) => {
      const id = Number(checkbox.dataset.addonVariant || 0);
      if (id) items.push({ id, quantity: 1, properties: { _addon_for: String(variantInput.value) } });
    });

    const submittedSelection = selectionKey();
    adding = true;
    addButton.disabled = true;
    addButton.setAttribute('aria-busy', 'true');
    addButton.classList.add('ew-pdp-loading');
    if (addLabel) addLabel.textContent = addButton.dataset.labelAdding;

    try {
      const response = await fetch(`${form.dataset.cartAddUrl || `${window.Shopify?.routes?.root || '/'}cart/add`}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : addButton.dataset.errorMessage);
      addedSelection = submittedSelection;
      adding = false;
      addButton.classList.remove('ew-pdp-loading');
      addButton.removeAttribute('aria-busy');
      syncVariant();
      try {
        const cartResponse = await fetch(`${form.dataset.cartUrl || '/cart'}.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('ethnicwish:cart-change', { detail: { item_count: cart.item_count } }));
        }
      } catch (_) {}

    } catch (error) {
      adding = false;
      addButton.classList.remove('ew-pdp-loading');
      addButton.removeAttribute('aria-busy');
      syncVariant();
      if (cartError) {
        cartError.textContent = error instanceof TypeError || error instanceof SyntaxError ? addButton.dataset.errorMessage : error.message;
        cartError.hidden = false;
        cartError.focus();
      }
    }
  });

  form?.addEventListener('input', () => syncVariant());
  form?.addEventListener('change', () => syncVariant());

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    addedSelection = null;
    adding = false;
    addButton?.classList.remove('ew-pdp-loading');
    addButton?.removeAttribute('aria-busy');
    syncVariant();
  });

  syncFitMode();
  syncVariant();
})();


